import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionEyebrow from "@/components/SectionEyebrow";

export default function FAQ({ items, eyebrow = "FAQ", title, gold }) {
    const [open, setOpen] = useState(0);
    if (!items || !items.length) return null;
    return (
        <section data-testid="faq-section" className="mx-auto max-w-4xl px-6 py-20 lg:px-10">
            <Reveal>
                <SectionEyebrow>{eyebrow}</SectionEyebrow>
            </Reveal>
            {title && (
                <Reveal delay={0.1}>
                    <h2 className="mt-5 font-display text-3xl font-medium tracking-tight sm:text-4xl">
                        {title} {gold && <span className="gold-text">{gold}</span>}
                    </h2>
                </Reveal>
            )}
            <div className="mt-10 space-y-3">
                {items.map((f, i) => {
                    const isOpen = open === i;
                    return (
                        <Reveal key={i} delay={i * 0.04}>
                            <div className={`overflow-hidden rounded-lg border transition ${isOpen ? "border-gold-300/30 glass" : "border-white/8 glass"}`}>
                                <button
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    data-testid={`faq-q-${i}`}
                                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                                >
                                    <span className="font-display text-base text-white/90 md:text-lg">{f.q}</span>
                                    <span className="flex-none text-gold-300">{isOpen ? <Minus size={18} /> : <Plus size={18} />}</span>
                                </button>
                                <AnimatePresence initial={false}>
                                    {isOpen && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.25 }}
                                        >
                                            <p data-testid={`faq-a-${i}`} className="px-6 pb-6 text-sm leading-relaxed text-white/65 md:text-base">
                                                {f.a}
                                            </p>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
}
